<template>
  <span class="text" @click="downLoad">{{text}}</span>
</template>

<script>
  import jsbarcode from 'jsbarcode';
  import saveAs from 'file-saver';

  export default {
    name: "orderBarCode",
    props: [
      'text',
    ],
    data() {
      return {};
    },
    methods: {
      downLoad() {
        var doctype = '<?xml version="1.0" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd" [<!ENTITY nbsp " ">]>';
        const barCode = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        jsbarcode(barCode, this.text, {
          lineColor: '#000',
          width: 1.5,
          height: 20,
          fontSize: 15,
          margin: 0,
        });
        const uri = 'data:image/svg+xml;base64,' + window.btoa(this.reEncode(doctype + barCode.outerHTML));
        saveAs(uri, this.text + '.svg');
      },
      reEncode(data) {
        data = encodeURIComponent(data);
        data = data.replace(/%([0-9A-F]{2})/g, function (match, p1) {
          const c = String.fromCharCode('0x' + p1);
          return c === '%' ? '%25' : c;
        });
        return decodeURIComponent(data);
      }
    }
  }
</script>

<style scoped>
  .text {
    cursor: pointer;
  }
</style>
